var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroesFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.085 17.887L9.851 9.7a2.8 2.8 0 012.683-1.917l-1 2.985a.106.106 0 00.028.11.124.124 0 00.096.04h1.465c.068 0 .137-.054.164-.123L16.764.5l-2.697 4.12a7.712 7.712 0 00-2.122-.287c-4.23.028-7.666 3.519-7.612 7.763a7.649 7.649 0 002.752 5.79zm4.792 1.78c4.23.054 7.735-3.355 7.79-7.585a7.665 7.665 0 00-2.752-5.969L14.15 14.3a2.86 2.86 0 01-2.697 1.93l1.163-3.436c.014-.041.014-.068-.014-.11-.027-.027-.054-.054-.095-.054h-1.465c-.082 0-.137.054-.165.123L7.236 23.5l2.683-4.12a7.6 7.6 0 001.958.287z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroesFill);
export default __webpack_public_path__ + "9ab6ed46fbdbe102ce70d9c5cb991b6d.svg";
export { ForwardRef as ReactComponent };